/**
 * components/ModuleHeader.js — Модулийн хуудасны толгой (banner).
 *
 * Хяналт шалгалтын хуудасны загварыг (градиент banner + цайвар гарчиг)
 * бүх модульд нэг эх сурвалжаас өгнө — өмнө нь хуудас бүр өөрийн `<h4>`
 * бичдэг байсан тул харагдац зөрдөг байв.
 *
 * Өнгө нь БҮДЭГ (ханалт багатай, гүн) байхаар сонгосон: banner нь бүтэн
 * өргөнөөр тархдаг тул тод өнгө нүд ядраадаг. Модуль тус бүрийн `theme.js`
 * дэх `*_BANNER` хосыг дамжуулна.
 *
 * <ModuleHeader
 *   from="#7C4A16" to="#A8712B"
 *   icon="fa-sun"
 *   title="ХАБ-н минут — бүртгэл"
 *   subtitle="Ажил эхлэхийн өмнөх ХАБ-ын мэдээлэл"
 *   extra={<Button …/>}          // баруун талд (заавал биш)
 * />
 */
import React from "react";
import PageHelp from "src/components/help/PageHelp";

export default function ModuleHeader({
  from,
  to,
  icon = "fa-clipboard-list",
  title,
  subtitle,
  extra = null,
  style,
}) {
  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${from} 0%, ${to} 100%)`,
        borderRadius: 14,
        padding: "16px 18px",
        marginBottom: 14,
        color: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
        ...style,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {icon ? <i className={"fas " + icon} style={{ fontSize: 24 }} /> : null}
        <div>
          {/* Гарчиг — ЦАЙВАР: banner нь аль хэдийн тод дэвсгэртэй тул
              гарчиг бүдүүн, цагаан байх шаардлагагүй. */}
          <h1
            style={{
              margin: 0,
              fontSize: 18,
              fontWeight: 500,
              letterSpacing: 0.3,
              color: "rgba(255,255,255,0.88)",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {title}
            {/* Тусламж — толгой ашигладаг БҮХ хуудсанд автоматаар.
                Түлхүүрийг замаасаа өөрөө уншина; тухайн хуудсанд заавар
                бичигдээгүй бол `PageHelp` өөрөө нуугдана. Ингэснээр шинэ
                хуудас нэмэхэд товч тавихаа мартах эрсдэлгүй. */}
            <PageHelp light />
          </h1>
          {subtitle ? (
            <p style={{ margin: "2px 0 0", fontSize: 12, opacity: 0.85 }}>
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {extra}
    </div>
  );
}

/** Banner дээрх тунгалаг товчны загвар — модуль бүрд ижил. */
export const headerButtonStyle = {
  background: "transparent",
  color: "#fff",
  border: "1px solid rgba(255,255,255,0.55)",
  padding: "10px 14px",
  borderRadius: 10,
  fontSize: 13,
  fontWeight: 700,
  height: "auto",
};
